import api from "@/services/api.js";
// import { uuid } from 'vue-uuid';

const getHomepages = async () => {
  const response = await api.get("/homepages");
  return response.data;
};

export default {
  getHomepages,
};
